import { render, staticRenderFns } from "./NeoparentAbout.vue?vue&type=template&id=12b6760f&scoped=true"
import script from "./NeoparentAbout.vue?vue&type=script&lang=js"
export * from "./NeoparentAbout.vue?vue&type=script&lang=js"
import style0 from "./NeoparentAbout.vue?vue&type=style&index=0&id=12b6760f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b6760f",
  null
  
)

export default component.exports